import { Injectable } from '@angular/core';
import * as $ from 'jquery';
import { Title } from '@angular/platform-browser';

declare let document: any;

interface Script {
  src: string;
  loaded: boolean;
}

export class ScriptGuru {
  public _scripts: Script[] = [];

  constructor(private titleService: Title) {

  }

  load(tag, ...scripts: string[]) {
    scripts.forEach((src: string) => {
      if (!this._scripts[src]) {
        this._scripts[src] = { src: src, loaded: false };
      }
    });

    let promises: any[] = [];
    scripts.forEach((src) => promises.push(this.loadScript(tag, src)));

    return Promise.all(promises);
  }

  loadScripts(tag, scripts, loadOnce?: boolean) {
    loadOnce = loadOnce || false;

    scripts.forEach((script: string) => {
      if (!this._scripts[script]) {
        this._scripts[script] = { src: script, loaded: false };
      }
    });

    let promises: any[] = [];
    scripts.forEach(
      (script) => promises.push(this.loadScript(tag, script, loadOnce)));

    return Promise.all(promises);
  }

  loadScript(tag, src: string, loadOnce?: boolean) {
    loadOnce = loadOnce || false;

    if (!this._scripts[src]) {
      this._scripts[src] = { src: src, loaded: false };
    }

    return new Promise((resolve, reject) => {
      // resolve if already loaded
      if (this._scripts[src].loaded && loadOnce) {
        resolve({ src: src, loaded: true });
      } else {
        // load script tag
        let scriptTag = $('<script/>').
          attr('type', 'text/javascript').
          attr('src', this._scripts[src].src);

        $(tag).append(scriptTag);

        this._scripts[src] = { src: src, loaded: true };
        resolve({ src: src, loaded: true });
      }
    });
  }

  loadStyles(tag, src) {
    if (Array.isArray(src)) {
      $.each(src, function (k, s) {
        $(tag).append($('<link/>').attr('href', s).attr('rel', 'stylesheet').attr('type', 'text/css'));
      });
    } else {
      $(tag).append($('<link/>').attr('href', src).attr('rel', 'stylesheet').attr('type', 'text/css'));
    }
  }

  unwrapTag(element: any) {
    $(element).removeAttr('appunwraptag').unwrap();
  }

  setPageTitle(title) {
    $('.m-subheader__title').text(title);
  }
  setBrowserTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  setBreadcrumbs(breadcrumbs) {
    if (breadcrumbs) {
      $('.m-subheader__title').addClass('m-subheader__title--separator');
    }

    let ul = $('.m-subheader__breadcrumbs');

    if ($(ul).length === 0) {
      ul = $('<ul/>').addClass('m-subheader__breadcrumbs m-nav m-nav--inline')
        .append($('<li/>').addClass('m-nav__item')
          .append($('<a/>').addClass('m-nav__link m-nav__link--icon')
            .append($('<i/>').addClass('m-nav__link-icon la la-home'))));
    }

    $(ul).find('li:not(:first-child)').remove();
    $.each(breadcrumbs, function (k, v) {
      const li = $('<li/>').addClass('m-nav__item')
        .append($('<a/>').addClass('m-nav__link m-nav__link--icon').attr('routerLink', v.href).attr('title', v.title)
          .append($('<span/>').addClass('m-nav__link-text').text(v.text)));
      $(ul).append($('<li/>').addClass('m-nav__separator').text('-')).append(li);
    });
    $('.m-subheader .m-stack__item:first-child').append(ul);
  }

  setLoading(enable) {
    const body = $('body');
    if (enable) {
      $(body).addClass('m-page--loading-non-block');
    } else {
      $(body).removeClass('m-page--loading-non-block');
    }
  }

  bodyClass(strClass) {
    $('body').attr('class', strClass);
  }

  scrollTo(el) {
    if (el && $(el)) {
      const top: number | undefined = $(el).offset().top;
      if (top) {
        $('html, body').animate({
          scrollTop: top - (top >= 60 ? 60 : 0)
        }, 1000);
      }
    }
  }
}



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/@systemic/helper/script.guru.ts